import { ReduxService } from 'dashboard-services/services';

import { csvBasicEditorActions } from 'actions/modules/tools';

export const csvBasicEditorInitialState = {
  editable: false,
  id: undefined,
  newFile: false,
  open: false,
  groupName: undefined,
  provider: undefined
}

export default (state = csvBasicEditorInitialState, action) => {
  switch (action.type) {
    case csvBasicEditorActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}